module.exports = __webpack_public_path__ + "img/stopwatch.f4f976df.svg";